<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="14" :md="14">
        <el-input v-model="filtro.nome" placeholder="Pesquisar por nome ou sigla" @keyup.native.enter="load"></el-input>
      </el-col>
      <el-col :xs="24" :sm="10" :md="10" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <router-link to="/admin/merenda/tabela-ingrediente/cadastro" class="btn-new-register" v-if="podeEscrever">
          <el-button type="primary">NOVA TABELA</el-button>
        </router-link>
      </el-col>
    </el-row>

    <el-alert class="u-mb-20" type="info" :closable="false" show-icon
      title="Tabela oficial (TACO, IBGE) é somente leitura nos valores nutricionais: o dado publicado não é editado por dentro do sistema. Para valores próprios do município, crie uma tabela própria."></el-alert>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Nome</th>
            <th style="width: 90px;">Sigla</th>
            <th class="hidden-mobile">Fonte</th>
            <th class="hidden-mobile u-text-center" style="width: 90px;">Versão</th>
            <th class="hidden-mobile u-text-center" style="width: 90px;">Oficial</th>
            <th class="hidden-mobile u-text-center" style="width: 110px;">Ingredientes</th>
            <th style="width: 140px;" class="u-text-center" v-if="podeEscrever">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome }}</td>
            <td><strong>{{ item.sigla }}</strong></td>
            <td class="hidden-mobile u-fs-12">{{ item.fonte || '—' }}</td>
            <td class="hidden-mobile u-text-center">{{ item.versao || '—' }}</td>
            <td class="hidden-mobile u-text-center">
              <el-tag v-if="item.padrao" size="mini" type="success">OFICIAL</el-tag>
              <span v-else>—</span>
            </td>
            <td class="hidden-mobile u-text-center">{{ item.alimentos_count !== undefined ? item.alimentos_count : '—' }}</td>
            <td class="u-text-center acao" v-if="podeEscrever">
              <router-link :to="'/admin/merenda/tabela-ingrediente/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain :disabled="item.padrao"></el-button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td :colspan="podeEscrever ? 8 : 7" class="u-text-center">Nenhuma tabela encontrada.</td>
          </tr>
        </tbody>
      </table>

      <el-row v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-mt-10">
            <small v-if="paginate.qtdItens">Exibindo {{ paginate.from }} a {{ paginate.to }} de {{ paginate.qtdItens }}</small>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 15">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="15" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: { nome: '' },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: []
  }),
  computed: {
    podeEscrever () {
      return [4, 5, 6].indexOf(Number(this.$store.state.user.tipo)) !== -1
    }
  },
  mounted () { this.load() },
  methods: {
    load () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/tabela-ingrediente/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir esta tabela?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/tabela-ingrediente/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(response => {
              window.eventBus.$emit('loading', false)
              if (response.data && response.data.erro) {
                return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
              }
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.load()
    }
  }
}
</script>
